import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {styled} from '@mui/material';
import * as React from 'react';
import {useCallback} from 'react';

export const Container = styled('div')(({theme}) => {
  const border = `1px solid ${theme.palette.grey['300']}`;
  const buttonSize = '60px';

  return ({
    borderBottom: border,
    display: 'flex',
    margin: 0,

    '& h2': {
      alignItems: 'center',
      borderLeft: border,
      borderRight: border,
      display: 'flex',
      flex: 1,
      fontSize: '1.4em',
      fontWeight: 700,
      justifyContent: 'center',
      margin: 0,
      padding: 0,
      textAlign: 'center',
    },

    '& button': {
      alignItems: 'center',
      background: 'none',
      border: 0,
      color: theme.palette.secondary.main,
      cursor: 'pointer',
      display: 'flex',
      height: buttonSize,
      justifyContent: 'center',
      margin: 0,
      padding: 0,
      width: buttonSize,

      '&:focus': {
        outline: 0,
      }
    }
  })
});

const YearSelector = ({year, onChange, loading}) => {

  const handleNext = useCallback(() => {
    onChange(year + 1);
  }, [year, onChange]);

  const handleBack = useCallback(() => {
    onChange(year - 1);
  }, [year, onChange]);

  return (
    <Container>
      <button onClick={handleBack}><ChevronLeftIcon/></button>
      <h2><span>{loading === '' ? year : loading}</span></h2>
      <button onClick={handleNext}><ChevronRightIcon/></button>
    </Container>
  )
};

export default YearSelector;
